import { useQuery } from '@tanstack/react-query';
import { getUsers, getHashtags, getUpdates, getSchedulerStatus } from '../api/client';
import StatsCard from '../components/StatsCard';
import RecentUpdates from '../components/RecentUpdates';
import TopHashtags from '../components/TopHashtags';

export default function Dashboard() {
  const { data: users } = useQuery({ queryKey: ['users'], queryFn: getUsers });
  const { data: hashtags } = useQuery({ queryKey: ['hashtags'], queryFn: getHashtags });
  const { data: updates } = useQuery({ queryKey: ['updates'], queryFn: () => getUpdates(7) });
  const { data: scheduler } = useQuery({ queryKey: ['scheduler'], queryFn: getSchedulerStatus });

  const totalUpdates = updates?.length || 0;
  const activeUsers = users?.filter(u => {
    const activity = (u as any).activity;
    return activity?.updates_last_7_days > 0;
  }).length || 0;

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-500 mt-1">Powering Executional Intelligence</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <StatsCard
          title="Updates This Week"
          value={totalUpdates}
          icon="📝"
          color="blue"
        />
        <StatsCard
          title="Active Users"
          value={activeUsers}
          subtitle={`of ${users?.length || 0} total`}
          icon="👥"
          color="green"
        />
        <StatsCard
          title="Hashtags"
          value={hashtags?.length || 0}
          icon="#️⃣"
          color="purple"
        />
        <StatsCard
          title="Scheduler"
          value={scheduler?.running ? 'Active' : 'Stopped'}
          subtitle={scheduler?.schedule}
          icon="⏰"
          color={scheduler?.running ? 'green' : 'red'}
        />
      </div>

      {/* Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <RecentUpdates updates={updates || []} />
        <TopHashtags hashtags={hashtags || []} />
      </div>
    </div>
  );
}
